import { createFeature } from '@edreamsodigeo/frontend-core';

export const PRIME_FREEZE_FEATURE = 'plus-9269-prime_freeze';
export const REDUCE_CANNIBALIZATION = 'fan_plus_9520';
export const AUTORENEWAL_ON_IN_DEPOSIT = 'fan_plus_10024';

export const featuredPrimeFreezeComponent = (Components) => {
  return createFeature({
    name: PRIME_FREEZE_FEATURE,
    variations: Components,
    version: 2,
  });
};

export const featuredReduceCannibalization = (Components) => {
  return createFeature({
    name: REDUCE_CANNIBALIZATION,
    variations: Components,
    version: 2,
  });
};

export const featuredAutoRenewalOnInDeposit = (Components) => {
  return createFeature({
    name: AUTORENEWAL_ON_IN_DEPOSIT,
    variations: Components,
    version: 2,
  });
};
